// @flow

import moment from 'moment';

// $FlowFixMe - direct import (instead of conditional "require") breaks webpack build) */
// const Austin = process.env.IN_CHROMECAST_MODE ? require('austinjs').default : {};
const Austin = process.env.IN_CHROMECAST_MODE ? require('Common/player/assets/austin.debug').default : {};

const SYNC_INTERVAL = 1000;

export class SlingSeekbarModifier {
  seekbarSyncIntervalID: IntervalID;
  castPlayer: HTMLDivElement;
  castControlsCurTime: HTMLDivElement;
  castControlsTotalTime: HTMLDivElement;
  castControlsProgressInner: HTMLDivElement;
  newCurrentTimeElement: HTMLDivElement;
  newTotalTimeElement: HTMLDivElement;
  newProgressInnerElement: HTMLDivElement;
  liveLabelElement: HTMLDivElement;
  isSeekbarModified: boolean;

  constructor() {}

  modify() {
    this._modifySeekbarUI();
  }

  restore() {
    this._restoreSeekbarUI();
  }

  _restoreSeekbarUI = () => {
    if (!this.isSeekbarModified) return;

    this.castControlsCurTime.hidden = false;
    this.castControlsTotalTime.hidden = false;
    this.castControlsProgressInner.hidden = false;

    this.newCurrentTimeElement.remove();
    this.newTotalTimeElement.remove();
    this.newProgressInnerElement.remove();

    this.liveLabelElement.className = 'liveLabel';

    clearInterval(this.seekbarSyncIntervalID);
    this.isSeekbarModified = false;
  };

  _getCastDOMElementById = (element: string) => {
    const { shadowRoot } = document.getElementsByTagName('cast-media-player')[0];
    let elem = shadowRoot.getElementById(element);
    if(!elem) {
      elem = this._getCastDOMElementBySelector(element);
    }
    return elem;
  };

  _getCastDOMElementBySelector = (element: string) => {
    const { shadowRoot } = document.getElementsByTagName('cast-media-player')[0];
    let elem = (shadowRoot).querySelectorAll(`.${element}`)[0];
    if(!elem) {
      const tvOverlay = shadowRoot.querySelector(`tv-overlay`);
      elem = (tvOverlay.shadowRoot).querySelector(`#${element}, *.${element}`);
    }
    return elem;
  };

  _getDisplayStatus = () => {
    const displayVal = this.castPlayer.attributes.getNamedItem('displaystatus')?.value;
    return displayVal ? JSON.parse(displayVal) : {};
  };

  _syncSeekbarUI = () => {
    this.seekbarSyncIntervalID = setInterval(() => {
      const displayStatus = this._getDisplayStatus();

      if (displayStatus) {
        const currentTime = Austin.getCurrentTime() / 1000;
        const totalTime = Austin.getDuration() / 1000;
        const progress = (currentTime * 100) / totalTime;

        this.newCurrentTimeElement.innerHTML = moment
          .utc(moment.duration(currentTime, 'seconds').as('milliseconds'))
          .format('HH:mm:ss');

        this.newTotalTimeElement.innerHTML = moment
          .utc(moment.duration(totalTime, 'seconds').as('milliseconds'))
          .format('HH:mm:ss');

        this.newProgressInnerElement.style.left = '0%';
        this.newProgressInnerElement.style.width = `${progress}%`;
    }
    }, SYNC_INTERVAL);
  };

  _modifySeekbarUI() {
    if (this.isSeekbarModified) return;

    this.castPlayer = this._getCastDOMElementById('castPlayer');
    this.castControlsCurTime = this._getCastDOMElementById('castControlsCurTime');
    this.castControlsTotalTime = this._getCastDOMElementById('castControlsTotalTime');
    this.castControlsProgressInner = this._getCastDOMElementById('castControlsProgressInner');
    this.liveLabelElement = this._getCastDOMElementBySelector('videoLiveIndicator').children[0];

    this.newCurrentTimeElement = this.castControlsCurTime.cloneNode(true);
    this.newTotalTimeElement = this.castControlsTotalTime.cloneNode(true);
    this.newProgressInnerElement = this.castControlsProgressInner.cloneNode(true);

    this._syncSeekbarUI();

    this.castControlsCurTime.hidden = true;
    this.castControlsTotalTime.hidden = true;
    this.castControlsProgressInner.hidden = true;

    this.liveLabelElement.className = 'liveLabel hidden';
    this.newProgressInnerElement.className = 'controlsProgressInner progressBar';

    const controlsTimelineLabels = this._getCastDOMElementBySelector('controlsTimelineLabels');
    const castControlsProgress = this._getCastDOMElementById('castControlsProgress');
    
    controlsTimelineLabels.appendChild(this.newCurrentTimeElement);
    controlsTimelineLabels.appendChild(this.newTotalTimeElement);
    castControlsProgress.appendChild(this.newProgressInnerElement);

    this.isSeekbarModified = true;
  }
}
